import React from "react";
import Table from "../../common/table/table";
import THead from "../../common/table/tHead";
import Tr from "../../common/table/tr";
import Th from "../../common/table/th";
import TBody from "../../common/table/tBody";
import Td from "../../common/table/td";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar";
import { ModalAlert } from "../../common/dialog/modalAlert";

export function ModalTabelaSaldosAgenciaVirtual(props) {
    if (!props.visible) return null;
    return (
        <ModalAlert titulo="" handleClose={props.handleClose} maxWidth={"95%"}>
            <div style={{ textAlign: "center" }}>
                <h4>Saldos da Agência Virtual em {props.saldosAgenciaVirtual.competencia_formatada}</h4>
            </div>
            <Table responsive>
                <THead>
                    <Tr style={{ backgroundColor: "#0077ff", color: "#FFF" }}>
                        <Th alignCenter> Descrição</Th>
                        <Th alignCenter> Ponta</Th>
                        <Th alignCenter> Fora Ponta</Th>
                        <Th alignCenter> Irrigante</Th>
                        <Th alignCenter> Intermediário</Th>
                        <Th alignCenter> Normal</Th>
                    </Tr>
                </THead>
                <TBody>
                    <Tr>
                        <Td alignCenter backgroundColor="#ff7952" color="#FFF">
                            kWh Gerado
                        </Td>
                        <Td alignCenter> {adicionarPontosMilhar(props.saldosAgenciaVirtual.kwh_gerado_ponta) + " kWh"}</Td>
                        <Td alignCenter> {adicionarPontosMilhar(props.saldosAgenciaVirtual.kwh_gerado_fora_ponta) + " kWh"}</Td>
                        <Td alignCenter> {adicionarPontosMilhar(props.saldosAgenciaVirtual.kwh_gerado_irrigante) + " kWh"}</Td>
                        <Td alignCenter> {adicionarPontosMilhar(props.saldosAgenciaVirtual.kwh_gerado_intermediario) + " kWh"}</Td>
                        <Td alignCenter> {adicionarPontosMilhar(props.saldosAgenciaVirtual.kwh_gerado_normal) + " kWh"}</Td>
                    </Tr>
                    <Tr>
                        <Td alignCenter backgroundColor="#12a0a7" color="#FFF">
                            kWh Creditado
                        </Td>
                        <Td alignCenter> {adicionarPontosMilhar(props.saldosAgenciaVirtual.kwh_creditado_ponta) + " kWh"}</Td>
                        <Td alignCenter> {adicionarPontosMilhar(props.saldosAgenciaVirtual.kwh_creditado_fora_ponta) + " kWh"}</Td>
                        <Td alignCenter> {adicionarPontosMilhar(props.saldosAgenciaVirtual.kwh_creditado_irrigante) + " kWh"}</Td>
                        <Td alignCenter> {adicionarPontosMilhar(props.saldosAgenciaVirtual.kwh_creditado_intermediario) + " kWh"}</Td>
                        <Td alignCenter> {adicionarPontosMilhar(props.saldosAgenciaVirtual.kwh_creditado_normal) + " kWh"}</Td>
                    </Tr>
                    <Tr>
                        <Td alignCenter backgroundColor="#11b35f" color="#FFF">
                            Saldo
                        </Td>
                        <Td alignCenter> {adicionarPontosMilhar(props.saldosAgenciaVirtual.saldo_ponta) + " kWh"}</Td>
                        <Td alignCenter> {adicionarPontosMilhar(props.saldosAgenciaVirtual.saldo_fora_ponta) + " kWh"}</Td>
                        <Td alignCenter> {adicionarPontosMilhar(props.saldosAgenciaVirtual.saldo_irrigante) + " kWh"}</Td>
                        <Td alignCenter> {adicionarPontosMilhar(props.saldosAgenciaVirtual.saldo_intermediario) + " kWh"}</Td>
                        <Td alignCenter> {adicionarPontosMilhar(props.saldosAgenciaVirtual.saldo_normal) + " kWh"}</Td>
                    </Tr>
                </TBody>
            </Table>
        </ModalAlert>
    );
}
